import { render } from "./KontaktOs.vue?vue&type=template&id=6311b0a0"
import script from "./KontaktOs.vue?vue&type=script&lang=js"
export * from "./KontaktOs.vue?vue&type=script&lang=js"

import "./KontaktOs.vue?vue&type=style&index=0&id=6311b0a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__